var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 93.57 101.08",
    style: {
      enableBackground: "new 0 0 93.57 101.08"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:var(--keysight-red);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.34,91.51v2.34c0,2.1-1.7,3.8-3.8,3.8H6.98c-2.1,0-3.8-1.7-3.8-3.8V7.14c0-2.1,1.7-3.8,3.8-3.8l44.29-0.03 V2.16h2.83v3.55l12.07,12.45h3.7v2.83h-1.54v24.2c0.51-0.03,1.02-0.06,1.53-0.06c0.44,0,0.87,0.01,1.3,0.04V19.25L52.97,0.48h-46 c-3.65,0-6.62,2.97-6.62,6.63v86.74c0,3.66,2.97,6.63,6.63,6.63h57.56c3.66,0,6.63-2.97,6.63-6.63v-2.32 c-0.43,0.02-0.86,0.04-1.3,0.04C69.35,91.57,68.84,91.54,68.34,91.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.99,21h12.34v-0.6l-2.17-2.24H55.99c-1.05,0-1.89-0.85-1.89-1.89V5.71l-2.32-2.4h-0.51v12.96 C51.27,18.88,53.38,20.99,55.99,21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "54.1,5.71 54.1,2.16 51.27,2.16 51.27,3.31 51.78,3.31  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "68.34,21 69.87,21 69.87,18.16 66.17,18.16 68.34,20.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.01,18.33c0-0.56,0-1.01,0-1.01H13.05c0,0,0,0.45,0,1.01v0.42h21.96V18.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.05,85.57v0.42h21.96v-0.42c0-0.56,0-1.01,0-1.01H13.05C13.05,84.56,13.05,85.01,13.05,85.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.81,36.89c0-0.65,0-1.17,0-1.17H13.05c0,0,0,0.53,0,1.17v0.1h45.77L58.81,36.89L58.81,36.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.24,46.56c0-0.62,0-1.13,0-1.13H12.92c0,0,0,0.5,0,1.13v0.19h39.32C52.24,46.75,52.24,46.56,52.24,46.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.05,74.84c0,0,0,0.53,0,1.17v0.1h34.94c-0.15-0.42-0.28-0.84-0.41-1.27H13.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.05,65c0,0,0,0.5,0,1.13v0.19h33.7c0.04-0.44,0.09-0.88,0.15-1.32C46.9,65,13.05,65,13.05,65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.05,55.28c0,0,0,0.52,0,1.16v0.13h36.82c0.26-0.44,0.53-0.87,0.82-1.29H13.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.39,67.64l-8.3,0.01h-2.46h-6.89c-0.1,0-0.18,0.08-0.18,0.18v10.3c0,0.1,0.08,0.18,0.18,0.18h6.89h2.46 h8.3c0.1,0,0.18-0.08,0.18-0.18V67.82C79.57,67.72,79.49,67.64,79.39,67.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.17,45.18c-0.43-0.02-0.86-0.04-1.3-0.04c-0.51,0-1.02,0.02-1.53,0.06C61,45.68,54.6,49.56,50.69,55.28 c-0.29,0.42-0.56,0.85-0.82,1.29c-1.5,2.54-2.53,5.39-2.97,8.43c-0.06,0.44-0.11,0.88-0.15,1.32c-0.06,0.67-0.09,1.35-0.09,2.04 c0,2.25,0.33,4.43,0.93,6.49c0.12,0.43,0.26,0.85,0.41,1.27c3.03,8.54,10.92,14.78,20.35,15.39c0.51,0.03,1.02,0.06,1.53,0.06 c0.44,0,0.87-0.01,1.3-0.04c12.21-0.68,21.91-10.79,21.91-23.17S83.38,45.86,71.17,45.18z M58.71,67.05 c0-0.94,0.76-1.71,1.71-1.71h2.75v-4.45c-0.03-1.87,0.69-3.68,2-5.02c0.86-0.93,1.97-1.57,3.18-1.88 c0.55-0.14,1.11-0.22,1.68-0.21h1.12c0.01,0,0.02,0,0.03,0c1.83-0.01,3.59,0.75,4.83,2.09c1.31,1.34,2.03,3.15,2,5.02v4.45h2.73 c0.94,0,1.71,0.76,1.71,1.71v11.84c0,0.94-0.77,1.71-1.71,1.71l-0.02-0.01h-9.54h-2.83h-7.92c-0.94,0-1.71-0.77-1.71-1.71v-2.77"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.77,65.38h2.28h4.28v-4.6c0.03-1.2-0.43-2.35-1.27-3.21c-0.77-0.85-1.86-1.32-3.01-1.32 c-0.01,0-0.03,0-0.04,0H70.1c-0.46-0.01-0.91,0.07-1.34,0.21c-0.65,0.22-1.24,0.59-1.71,1.11c-0.84,0.85-1.3,2.01-1.27,3.21 l0.01,4.6H68.77z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseManagement);
export default __webpack_public_path__ + "static/media/license-management.644c4cdf283e54c279cf89eb5b3c270f.svg";
export { ForwardRef as ReactComponent };